import React, { useRef } from "react"
import { Appearance, TextInput } from "react-native"
import { observer } from "mobx-react-lite"
import { Text } from "../text/text"
import { TxKeyPath, translate } from "../../i18n"
import { NumeralField } from "../field/numeral-field/numeral-field"
import { Formik } from "formik"
import * as yup from "yup"
import _ from "lodash"
import { FormProps } from "../form/form"
import { View } from "native-base"
import { JalaIcon } from "../jala-icon/jala-icon"
import { InfoModal } from "../auto-feeder-setup-normal-form/auto-feeder-setup-normal-form"
import { color } from "../../theme"

export interface AutoFeederPondContinueFormProps extends FormProps {
  colorScheme?: "light" | "dark",
  initialValues?: { interval?: number, onTime?: number },
}

/**
 * Describe your component here
 */
export const AutoFeederPondContinueForm = observer(function AutoFeederPondContinueForm(props: AutoFeederPondContinueFormProps) {
  const { initialValues = {}, colorScheme = "light" || Appearance.getColorScheme(), onSubmit, innerRef, ...rest  } = props

  const input = {
    interval: useRef<TextInput>(),
    onTime: useRef<TextInput>(),
  }

  const nextInput = {
    interval: () => input.onTime.current && input.onTime.current.focus(),
  }

  const validationSchema = yup.object({
    interval: yup.number().nullable().required().label(translate("autoFeederPondCreateWizardScreen.debit")),
    onTime: yup.number().nullable().required().label(translate("autoFeederPondCreateWizardScreen.onTime")),
  })

  const unitElement = (type) => <View pr="8px">
    <Text text={translate(`autoFeederPondCreateWizardScreen.${type}Unit` as TxKeyPath)} preset="title4" />
  </View>

const labelComponentWithInfo = () => (
  <InfoModal>
    <View flexDirection="row" alignItems="center">
      <Text tx="autoFeederPondCreateWizardScreen.onTime" preset="title4" colorScheme={colorScheme} mr="6px" />
      <JalaIcon name="info-1" size={16} color={color.palette.gray800} />
    </View>
  </InfoModal>
)

  return (
    <Formik
      initialValues={{ ...initialValues }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
    {({ isValid, handleSubmit, values, initialValues }) => (
      <>
        <NumeralField
          name="interval"
          txPrefix="autoFeederPondCreateWizardScreen"
          colorScheme={colorScheme}
          input={input}
          nextInput={nextInput}
          formControlProps={{
            style: { paddingHorizontal: 0 },
            inputProps: { placeholder: '-', InputRightElement: unitElement('duration') } ,
            helperText: translate("autoFeederPondCreateWizardScreen.intervalHelper"),
            helperTextPreset: "body3"
          }}
        />
        <NumeralField
          name="onTime"
          txPrefix="autoFeederPondCreateWizardScreen"
          colorScheme={colorScheme}
          input={input}
          nextInput={nextInput}
          formControlProps={{
            labelComponent: labelComponentWithInfo(),
            style: { paddingHorizontal: 0 },
            inputProps: { placeholder: '-', InputRightElement: unitElement('onTime') },
            helperText: translate("autoFeederPondCreateWizardScreen.onHelper"),
            helperTextPreset: "body3"
          }}
        />
      </>
    )}
    </Formik>
  )
})
